import React, { useState, useEffect } from 'react';
import { useQuestionBook } from '@/hooks/useQuestionBook';
import { ExercisesCard } from './exercises-card';
import { useFormik } from 'formik';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { ExercisesForm } from './exercises-form';
import { useTranslation } from 'react-i18next';
import { Filter, FilterActions, FilterContent } from '@/components/custom/filter';
import { Button } from '@/components/ui/button';
import { CardWrapper } from '@/components/ui/card';
import { Sheet, SheetBody, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { DialogTitle } from '@/components/ui/dialog';

export function ExercisesArchive() {
  const { t } = useTranslation();
  const { questionBooks, getQuestionBooks, loading } = useQuestionBook();
  const [showModal, setShowModal] = useState(false);
  const [filteredQuestionBooks, setFilteredQuestionBooks] = useState([]);

  const filters = useFormik({
    initialValues: {
      course: 'blank',
      classroom: 'blank',
      visibility: {
        public: false,
        own: false
      }
    }
  });

  function filterQuestionBooksByCourse(id, questionBooks) {
    return questionBooks.filter(function (qb) {
      return qb['course-ids'].includes(id);
    });
  }

  function filterQuestionBooksByClassroom(id, questionBooks) {
    return questionBooks.filter(function (qb) {
      return qb['classroom-ids'].includes(id);
    });
  }

  useEffect(() => {
    let newQuestionBooks = questionBooks;
    if (filters.values.course !== 'blank') {
      const id = +filters.values.course;
      newQuestionBooks = filterQuestionBooksByCourse(id, questionBooks);
    }
    if (filters.values.classroom !== 'blank') {
      const id = +filters.values.classroom;
      newQuestionBooks = filterQuestionBooksByClassroom(id, questionBooks);
    }
    if (filters.values.visibility.public === true) {
      newQuestionBooks = newQuestionBooks.filter(qb => qb['creator-profile'] !== 'Aluno');
    }
    if (filters.values.visibility.own === true) {
      newQuestionBooks = newQuestionBooks.filter(qb => qb['creator-profile'] === 'Aluno');
    }
    setFilteredQuestionBooks(newQuestionBooks.filter(item => item['question-count'] > 0));
  }, [filters.values, questionBooks]);

  useEffect(() => {
    getQuestionBooks();
  }, []);

  return (
    <>
      <Filter
        variant="plain"
        className="mb-4 md:mb-0"
      >
        <FilterContent />

        <FilterActions>
          <Sheet
            open={showModal}
            onOpenChange={setShowModal}
          >
            <SheetTrigger asChild>
              <Button
                wide
                isAlignedWithTabs
              >
                {t('questionBooks.buttonNewQuestionBook')}
              </Button>
            </SheetTrigger>

            <SheetContent>
              <DialogTitle className="sr-only">Novo exercício</DialogTitle>
              <SheetBody className="py-6">
                <ExercisesForm setShowModal={setShowModal} />
              </SheetBody>
            </SheetContent>
          </Sheet>
        </FilterActions>
      </Filter>

      {loading && <Loader />}

      {!loading && !filteredQuestionBooks.length > 0 && <EmptyState type="data" />}

      {!loading && (
        <CardWrapper className="animate-fade-in">
          {filteredQuestionBooks?.map(qb => (
            <ExercisesCard
              key={qb.id}
              book={qb}
            />
          ))}
        </CardWrapper>
      )}
    </>
  );
}
